// src/app/buildVersion.ts
/** [جديد 3/11/2026 — "رقم إصدار في الهيدر عشان نتأكد إن كل رفع فرونت إند جديد فعلاً وصل السيرفر"] رقم
 * ثابت بسيط (مش build hash تلقائي — محتاج أداة بناء إضافية مش موجودة هنا) بيتزوّد يدوياً في كل مرة
 * بتتسلّم فيها نسخة فرونت إند جديدة. بعد ما ترفع أي زيب فرونت إند جديد، افتح أي صفحة في اللوحة وشوف
 * الرقم ده في الهيدر فوق — لو اتغيّر عن اللي كان ظاهر قبل الرفع، يبقى التحديث وصل فعلاً؛ لو فضل زي ما هو،
 * يبقى السيرفر لسه بيقدّم نسخة قديمة (كاش المتصفح/CDN، أو الرفع ما حصلش فعلياً). */
export const FRONTEND_BUILD_VERSION = "2026-11-03.9";
